<template>
    <el-dialog
        :before-close="handleDialogClose"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :visible.sync="clockInRecordDialogVisible"
        class="custom_form_dialog custom_days_detail_dialog"
        :title="userName + '的打卡记录'"
        width="810px"
    >
        <el-table
            class="custom_table"
            :data="individualTableData"
            :span-method="objectSpanMethod"
            border
            height="300px"
            :max-height="590"
            ref="detailsTable"
        >
            <el-table-column label="打卡日期" prop="" width="160">
                <template slot-scope="{ row }">
                    <span>{{ row.web_show_date }}</span>
                </template>
            </el-table-column>
            <el-table-column label="打卡次数" prop="" align="right" width="82">
                <template slot-scope="{ row }">
                    <span>{{ row.punch_times }}</span>
                </template>
            </el-table-column>
            <el-table-column label="打卡时间" prop="" width="158">
                <template slot-scope="{ row }">
                    <span>{{ row.punch_time_string }}</span>
                </template>
            </el-table-column>
            <el-table-column label="打卡地址" prop="" width="276" show-overflow-tooltip>
                <template slot-scope="{ row }">
                    <span>{{ (row.detail && row.detail.punch_type == 'INTERVAL') ? row.detail && row.detail.start.location === row.detail.end.location ? row.detail.start.address : (row.detail.start.address + '、' + row.detail.end.address_end)  : row.detail.address}}</span>
                </template>
            </el-table-column>
            <el-table-column label="打卡详情" prop="" width="84">
                <template slot-scope="{ row }">
                    <span class="link-label" @click="handleClickDetail(row)">详情</span>
                </template>
            </el-table-column>
        </el-table>
        <el-drawer
            size="520px"
            :append-to-body="true"
            direction="rtl"
            class="custom_drawer custom_clockIn_detail_drawer"
            :visible.sync="detailVisible"
            :withHeader="false"
            :close-on-press-escape="false"
            :before-close="handleDrawerClose"
        >
            <div class="drawer_wrap">
                <div class="drawer_header">
                    <h3 class="title" v-text="'打卡详情'"></h3>
                    <span class="handle_icon_wrap" @click="handleDrawerClose">
                        <i class="el-icon-close"></i>
                    </span>
                </div>
                <div class="drawer_body" v-loading="loading">
                    <ul class="detail_list">
                        <li class="detail_list_item" v-for="(item, index) in detailRecordList">
                            <p v-if="index == 0" class="item_title">
                                {{ detailRecordList.length > 1 ? "开始时间" : "打卡时间" }}
                            </p>
                            <p
                                v-else-if="index === detailRecordList.length - 1 && detailRecordList.length > 1"
                                class="item_title"
                            >
                                结束时间{{ item.is_skip? "（无需打卡）" : "" }}
                            </p>
                            <p v-else></p>
                            <template v-if="!item.is_skip">
                                <div class="list_time"><i class="iconfont icon-shijian"></i>{{ item.punch_at_show }}</div>
                                <div><i class="iconfont icon-weizhi1"></i>{{ item.address || item.address_end}}</div>
                                <div v-if="item.images && item.images.length">
                                    <ul class="voucher_list">
                                        <li :key="imgIndex" class="voucher_item" v-for="(img, imgIndex) in item.images">
                                            <el-image
                                                :preview-src-list="item.images"
                                                :src="img"
                                                alt=""
                                                style="max-width: 44px; max-height: 44px"
                                            ></el-image>
                                        </li>
                                    </ul>
                                </div>
                                <div>{{ item.remark }}</div>
                            </template>
                        </li>
                    </ul>
                </div>
            </div>
        </el-drawer>
    </el-dialog>
</template>

<script>
import { GetAdminIndividualAttendanceCheck } from "@/api";
export default {
    name: "ClockInRecordDetails",
    props: {
        clockInRecordDialogVisible: {
            type: Boolean,
            default: false,
        },
        userName: {
            type: String,
            default: "张三",
        },
        // 查询参数
        queryParams: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            individualTableData: [],
            batchRowArray: {}, // 记录合并行
            detailVisible: false,
            detailRecordList: [], // 打卡详情数据
            loading: false,
        };
    },
    created() {
        if (this.clockInRecordDialogVisible && this.queryParams && this.queryParams.uid) {
            this.getAdminIndividualAttendanceCheckData();
        }
    },
    methods: {
        // 弹框关闭
        handleDialogClose() {
            this.$emit("update:clockInRecordDialogVisible", false);
        },
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            if (columnIndex === 0 || columnIndex === 1) {
                if (this.batchRowArray[rowIndex]) {
                    return {
                        rowspan: this.batchRowArray[rowIndex],
                        colspan: 1,
                    };
                } else {
                    return {
                        rowspan: 0,
                        colspan: 0,
                    };
                }
            }
        },
        // 查看某人的打卡详情
        getAdminIndividualAttendanceCheckData() {
            GetAdminIndividualAttendanceCheck(this.queryParams).then((res) => {
                if (res.code === 200) {
                    let data = res.data || [];
                    var batchRowArray = {};
                    var batchData = [];
                    data.forEach((item) => {
                        if (item.list.length) {
                            item.list = item.list.map((listItem) => ({
                                ...listItem,
                                date: item.date,
                                punch_times: item.punch_times,
                                web_show_date: item.web_show_date
                                // list: item.list,
                            }));
                            batchRowArray[batchData.length > 0 ? batchData.length : 0] = item.list.length;
                            batchData.concat(item.list);
                            batchData = [...batchData, ...item.list];
                        }
                    });
                    this.individualTableData = batchData;
                    this.batchRowArray = batchRowArray;
                }
            });
        },
        // 查看某条数据的打卡详情明细
        handleClickDetail(row) {
            let detailRecordList = [];
            if (row.detail.punch_type == "SINGLE") {
                detailRecordList.push(row.detail);
            } else {
                detailRecordList = [
                    { punch_type: row.detail.punch_type, ...row.detail.start },
                    { punch_type: row.detail.punch_type, ...row.detail.end },
                ];
            }
            this.detailRecordList = detailRecordList;
            this.detailVisible = true;
        },
        // 打卡详情关闭
        handleDrawerClose() {
            this.detailVisible = false;
        },
    },
};
</script>

<style lang="scss">
.custom_days_detail_dialog {
    .el-dialog__body {
        padding: 24px !important;
    }
}
.custom_table {
    ::v-deep thead {
        th {
            font-weight: 400;
        }
        .cell {
            font-weight: 400 !important;
        }
    }
}
.custom_clockIn_detail_drawer {
    .drawer_wrap {
        .drawer_header {
            box-shadow: inset 0px -1px 0px rgba(0, 0, 0, 0.08);
        }
        .drawer_body {
            background-color: #ffffff;
            .detail_list {
                padding: 20px 16px;
                .detail_list_item {
                    width: 100%;
                    padding-left: 10px;
                    padding-bottom: 16px;
                    box-sizing: border-box;
                    position: relative;
                    &::before {
                        width: 6px;
                        height: 6px;
                        opacity: 1;
                        border-radius: 50%;
                        content: " ";
                        left: 0;
                        top: 6px;
                        position: absolute;
                        background: rgba(41, 144, 255, 1);
                        z-index: 10;
                    }
                    &::after {
                        width: 1px;
                        height: 100%;
                        position: absolute;
                        left: 2.5px;
                        top: 6px;
                        background-color: rgba(0, 0, 0, 0.08);
                        content: " ";
                    }
                    .item_title {
                        font-size: 12px;
                        font-weight: 400;
                        letter-spacing: 0px;
                        line-height: 18px;
                        color: rgba(153, 153, 153, 1);
                        margin-bottom: 12px;
                    }
                    .iconfont {
                        font-size: 14px;
                        color: rgba(102, 102, 102, 1);
                        margin-right: 4px;
                    }
                    & > div {
                        & + div {
                            margin-top: 8px;
                        }
                        font-size: 14px;
                        font-weight: 400;
                        letter-spacing: 0px;
                        line-height: 22px;
                        color: rgba(102, 102, 102, 1);
                    }
                    .list_time {
                        font-weight: 700;
                        color: rgba(51, 51, 51, 1);
                    }
                }
            }
            .voucher_list {
                display: flex;
                gap: 8px;
                .voucher_item {
                    width: 44px;
                    height: 44px;
                    cursor: pointer;
                    position: relative;
                    text-align: center;
                    border-radius: 4px;
                    img {
                        max-width: 100%;
                        max-height: 100%;
                        object-fit: cover;
                    }
                }
            }
        }
    }
}
</style>
